/* Galil Coffee: progressive portrait-card enhancement for The Ledger - 2026-07-26 */

(() => {
  const directory = document.querySelector('[data-galil-ledger-directory]');
  if (!directory || directory.dataset.galilLedgerReady === 'true') return;

  directory.dataset.galilLedgerReady = 'true';

  const portraitBase = directory.dataset.portraitBase;
  const fallbackPortrait = directory.dataset.fallbackPortrait;
  const fallbackPersonPortrait = directory.dataset.fallbackPersonPortrait;
  const attributionUrl = directory.dataset.attributionUrl;
  const cards = [];
  const individualFallbackHandles = new Set([
    'kingsley-wilson-antisemitism',
    'ms-rachel-israel',
    'roberto-lopes-israel',
  ]);

  const pageHandleFrom = (href) => {
    try {
      const parts = new URL(href, window.location.origin).pathname.split('/').filter(Boolean);
      return parts[0] === 'pages' ? parts[1] : '';
    } catch (_error) {
      return '';
    }
  };

  directory.querySelectorAll('.rte > ul > li').forEach((item) => {
    const recordLink = item.querySelector('a[href^="/pages/"]');
    if (!recordLink) return;

    const handle = pageHandleFrom(recordLink.href);
    if (!handle) return;

    const displayName = recordLink.textContent.trim();
    const fallbackForRecord = individualFallbackHandles.has(handle)
      ? fallbackPersonPortrait
      : fallbackPortrait;
    const media = document.createElement('div');
    const portraitLink = document.createElement('a');
    const portrait = document.createElement('img');
    const body = document.createElement('div');

    item.classList.add('galil-ledger-card');
    media.className = 'galil-ledger-card__media';
    portraitLink.className = 'galil-ledger-card__portrait-link';
    portraitLink.href = recordLink.href;
    portraitLink.setAttribute('aria-label', `Read the full record for ${displayName}`);

    portrait.className = 'galil-ledger-card__portrait';
    portrait.src = fallbackForRecord;
    portrait.alt = `Editorial illustration for ${displayName}`;
    portrait.width = 480;
    portrait.height = 600;
    portrait.loading = 'lazy';
    portrait.decoding = 'async';
    portrait.dataset.recordHandle = handle;
    portrait.dataset.fallback = 'true';
    portrait.addEventListener(
      'error',
      () => {
        if (portrait.src === fallbackForRecord) return;
        portrait.src = fallbackForRecord;
        portrait.alt = `Editorial illustration for ${displayName}`;
        portrait.dataset.fallback = 'true';
      },
      { once: true }
    );

    body.className = 'galil-ledger-card__body';
    while (item.firstChild) body.appendChild(item.firstChild);
    portraitLink.appendChild(portrait);
    media.appendChild(portraitLink);
    item.append(media, body);
    item.parentElement.classList.add('galil-ledger-grid');

    cards.push({ item, media, portrait, handle, displayName });
  });

  if (!cards.length || !attributionUrl) return;

  fetch(attributionUrl)
    .then((response) => {
      if (!response.ok) throw new Error(`Portrait attribution returned ${response.status}`);
      return response.json();
    })
    .then((records) => {
      const attributionByHandle = new Map(records.map((record) => [record.handle, record]));
      const usedRecords = [];

      cards.forEach(({ item, media, portrait, handle, displayName }) => {
        const record = attributionByHandle.get(handle);
        if (!record) {
          return;
        }

        usedRecords.push(record);
        portrait.src = `${portraitBase}galil-ledger-${handle}.webp`;
        portrait.alt =
          record.kind === 'brand'
            ? `Brand image for ${displayName}`
            : `Portrait of ${displayName}`;
        delete portrait.dataset.fallback;
        item.dataset.ledgerKind = record.kind || 'person';

        const source = document.createElement('a');
        source.className = 'galil-ledger-card__source';
        source.href = record.source;
        source.target = '_blank';
        source.rel = 'noopener noreferrer';
        source.textContent = 'Photo ↗';
        source.title = `${record.creator} · ${record.license}`;
        source.setAttribute(
          'aria-label',
          `Portrait source for ${displayName}: ${record.creator}, ${record.license}`
        );
        media.appendChild(source);
      });

      if (!usedRecords.length) return;

      const details = document.createElement('details');
      const summary = document.createElement('summary');
      const list = document.createElement('ul');

      details.className = 'galil-ledger-credits';
      summary.textContent = 'Image credits & licenses';
      details.append(summary, list);

      usedRecords.forEach((record) => {
        const item = document.createElement('li');
        const source = document.createElement('a');

        source.href = record.source;
        source.target = '_blank';
        source.rel = 'noopener noreferrer';
        source.textContent = record.name;

        item.append(source, ` — ${record.creator}; `);

        if (record.license_url) {
          const license = document.createElement('a');
          license.href = record.license_url;
          license.target = '_blank';
          license.rel = 'license noopener noreferrer';
          license.textContent = record.license;
          item.appendChild(license);
        } else {
          item.append(record.license);
        }

        list.appendChild(item);
      });

      directory.appendChild(details);
    })
    .catch((error) => {
      console.warn('Galil Ledger portrait credits unavailable:', error);
    });
})();
